import { CalendarEventTypes } from "@/modules/calendar/calendarTypes"
import {
  ProgramInfiniteSessionTypeOf,
  ProgramOnOffSessionTypeOf,
  SessionTypeOf,
} from "@/modules/sessions/programSessionTypes"
import type { TrainingCalendarEventType } from "@/modules/training/components/trainingCalendarEvent"
import type { TrainingItemEntityType } from "@/modules/training/entities/trainingContentEntity"
import {
  TrainingBoxSlotEntity,
  TrainingProgramInfiniteSessionEntity,
  TrainingProgramOnOffSessionEntity,
} from "@/modules/training/entities/trainingContentItemEntity"
import { BoxSlotTypeOf } from "@modules/boxSlot/boxSlotTypes"

export const TrainingContentTypes = [SessionTypeOf, BoxSlotTypeOf] as const
export type TrainingContentType = (typeof TrainingContentTypes)[number]

export const AvailableTrainingContentTypes: TrainingContentType[] = [SessionTypeOf, BoxSlotTypeOf]

export const convertItemTrainingSessionsToEvent = (
  trainingSessions: TrainingItemEntityType[],
  userId: string,
): TrainingCalendarEventType[] => {
  return trainingSessions.map((session) => {
    const isProgramUser =
      (session instanceof TrainingBoxSlotEntity && session.owner.id === userId) ||
      (session instanceof TrainingProgramInfiniteSessionEntity && session.owner?.id === userId) ||
      (session instanceof TrainingProgramOnOffSessionEntity && session.owner.id === userId)

    return {
      id: session.content.id,
      sessionType:
        session.type === BoxSlotTypeOf
          ? BoxSlotTypeOf
          : session.content instanceof TrainingProgramInfiniteSessionEntity
            ? ProgramInfiniteSessionTypeOf
            : ProgramOnOffSessionTypeOf,
      title: session.type === BoxSlotTypeOf ? session.content.program.name : session.content.name,
      date: session.type === BoxSlotTypeOf ? session.content.startDate : (session.content.date ?? ""),
      programId: session.type === BoxSlotTypeOf ? session.content.program.id : session.content.programId,
      programName: session.type === BoxSlotTypeOf ? session.content.program.name : session.content.programName,
      editable: isProgramUser,
      virtualProgramByDateIndex:
        session.type === SessionTypeOf && session.content instanceof TrainingProgramInfiniteSessionEntity
          ? (session.content.virtualProgramByDateIndex ?? undefined)
          : undefined,
      author: session.type === BoxSlotTypeOf ? session.content.owner : session.content.owner,
      boxName: session.type === BoxSlotTypeOf ? session.content.box.name : undefined,
      participantCount: session.type === BoxSlotTypeOf ? session.content.registeredParticipantCount : undefined,
      participantStatus: session.type === BoxSlotTypeOf ? session.content.participantStatus : undefined,
      participantLimit: session.type === BoxSlotTypeOf ? (session.content.participantLimit ?? undefined) : undefined,
      isAuthor: isProgramUser,
      programVisibility:
        session.type === SessionTypeOf && session.content instanceof TrainingProgramInfiniteSessionEntity
          ? session.content.programVisibility
          : undefined,
      hideSessionContent:
        session.type === SessionTypeOf && session.content instanceof TrainingProgramInfiniteSessionEntity
          ? session.content.hideSessionContent
          : false,
      _type: CalendarEventTypes.CALENDAR_EVENT,
    }
  })
}
